module.exports = __webpack_public_path__ + "static/media/1-1_Art_Card_One_Page_01.cbda4b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/1-1_Art_Card_One_Page_01.jpg
// module id = 1698
// module chunks = 0